declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}

export function trackEvent(eventName: string, eventParams: Record<string, string | number | boolean> = {}): void {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
  }
}

export function trackFormSubmission(params: {
  form_id: string;
  formula?: string;
  delay?: string;
  priority?: string;
  country?: string;
}): void {
  trackEvent('form_submission', {
    form_id: params.form_id,
    formula: params.formula || '',
    delay: params.delay || '',
    priority: params.priority || '',
    country: params.country || '',
  });
}
